/**
 * Normalização de texto usada em toda comparação de nome, status e procedimento.
 * Reproduz o que o VBA fazia à mão (maiúsculas, acentos removidos, espaços
 * colapsados), o que importa porque a planilha listava "Desmarcado pela clinica"
 * e "Desmarcado pela clínica" como se fossem dois status diferentes.
 */
export function normalizar(texto: string | null | undefined): string {
  if (texto === null || texto === undefined) return '';
  return String(texto)
    .replace(/\u00a0/g, ' ')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Arredondamento decimal estável. Sem o passo intermediário, resíduo binário
 * (750 * 1,05 = 787,5000000000001) vaza para o valor pago.
 */
export function arredondar(valor: number, casas: number): number {
  if (!Number.isFinite(valor)) return 0;
  const fator = 10 ** casas;
  const escalado = Math.round(valor * fator * 1e8) / 1e8;
  return Math.round(escalado) / fator;
}

/** Arredonda uma fração pelas casas do PERCENTUAL: 0,803312 com 2 casas -> 0,8033. */
export function arredondarTaxa(taxa: number, casasPercentuais: number | null): number {
  if (casasPercentuais === null) return taxa;
  return arredondar(taxa * 100, casasPercentuais) / 100;
}

const FORMATO_REAIS = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

/** Formata fração como percentual, para o memorial e o comprovante. */
export function formatarPercentual(taxa: number, casas = 2): string {
  return `${(taxa * 100).toFixed(casas).replace('.', ',')}%`;
}

/** Formata valor em reais, para o memorial e o comprovante. */
export function formatarReais(valor: number): string {
  return FORMATO_REAIS.format(valor);
}
